
import React from "react";
import { FileText, Image, File } from "lucide-react";

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const getFileIcon = (fileType: string) => {
  if (fileType.startsWith('image/')) {
    return <Image className="w-5 h-5" />;
  } else if (fileType === 'application/pdf') {
    return <FileText className="w-5 h-5" />;
  } else {
    return <File className="w-5 h-5" />;
  }
};
